module.exports = __webpack_public_path__ + "694d4a752e221fff28f6dc81443da7e0.svg";